import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsMessageComponent} from "@wms/components";

@Component({
  selector: 'wms-ptt-summary',
  standalone: true,
  imports: [CommonModule, WmsMessageComponent],
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.less']
})
export class SummaryComponent extends BaseComponent {
  @Input() artifactPublishDetails: any;
  @Input() isPublishSuccessful: boolean;
  @Input() showErrMsg: boolean;
  @Input() errMsg: string;
  @Input() successMessage: string;

  constructor() {
    super();
  }

}
